import React from 'react'
import CopyToClipboardUI from '../../../widgets/output/CopyToClipboardUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SearchUI from '../../../widgets/input/SearchUI'
import './AccountList.css'

const DocumentRepositoryAccountListUI = ({ context, accountList, onRowClick, onRefreshClick,
  searchFilter, onSearchFilterChange, onCopyToClipboard, copyToClipboardText
}) =>
  <div className='su_accs'>
    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
          <span className='g_m_left_100 g_large'><b>Document Repository</b></span>
        </div>
      }
      right={
        <SearchUI value={searchFilter} onChange={onSearchFilterChange} placeholder='Search by account name' />
      }
    />

    <div className='g_flex_h g_m_bottom_50'>
      <span>{accountList.length} account{accountList.length == 1 ? '' : 's'} displayed</span>
    </div>

    <LRTableBodyUI>
      {
        accountList.map((account, i) =>
          <LRTableRowUI
            key={i}
            context={context}
            left={
              <div className='g_flex_v'>
                <span><b>{account.accountName}</b></span>
                <span className='g_flex_h g_muted g_flex_left'>
                  <span className='g_m_right_100'>{account.dateCreatedF1}</span>
                  <CopyToClipboardUI text={account.accountId}
                    onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
                  />
                </span>
              </div>
            }
            right={<span />}
            onClick={onRowClick}
            rowId={account.accountId}
          />
        )
      }
    </LRTableBodyUI>
  </div>

export default DocumentRepositoryAccountListUI